import React, { Fragment } from "react";
import { Text, View, StyleSheet } from "@react-pdf/renderer";
import NoData from "./NoData";

const CarTableData = ({ data }) => {
  const styles = StyleSheet.create({
    carcontainer: {
      flexDirection: "row",
      alignItems: "center",
      fontStyle: "bold",
      paddingBottom: "5px",
      paddingTop: "10px",
      paddingLeft: "15px",
      border: "1px solid #E4E4E4",
      borderRadius: "5px",
      width: "100%",
      marginTop: "5px",
    },
    departure: {
      width: "20%",
      fontSize: "11px",
      color: "#333333",
    },
    arrival: {
      width: "20%",
      fontSize: "11px",
      color: "#333333",
    },
    form: {
      width: "15%",
      fontSize: "11px",
      color: "#333333",
    },
    to: {
      width: "15%",
      fontSize: "11px",
      color: "#333333",
    },
    description: {
      width: "20%",
      fontSize: "11px",
      color: "#333333",
    },
  });
  return (
    <Fragment>
      {data && data?.car_rentals?.length > 0 ? (
        data?.car_rentals?.map((items) => (
          <View style={styles.carcontainer}>
            <Text style={styles.departure}>
              {items?.duration_from ? items?.duration_from : "-"}
            </Text>
            <Text style={styles.arrival}>
              {items?.duration_to ? items?.duration_to : "-"}
            </Text>
            <Text style={styles.form}>{items?.city ? items?.city : "-"}</Text>
            <Text style={styles.to}>{items?.city ? items?.city : "-"}</Text>
            <Text style={styles.description}>
              {items?.description ? items?.description : "-"}
            </Text>
          </View>
        ))
      ) : (
        <NoData title="Car Data" />
      )}
    </Fragment>
  );
};

export default CarTableData;
